import { create } from 'zustand';
import { Appointments } from '../../../modules/appointmentBook';

interface IStore {
  appointments: Appointments[];
  setAppointments: (prop: Appointments[]) => void;
  selectedAppointment: Appointments;
  setSelectedAppointment: (prop: Appointments) => void;
}

export const useAppointments = create<IStore>(set => ({
  appointments: [],
  setAppointments: appointments => set(() => ({ appointments })),
  selectedAppointment: {} as Appointments,
  setSelectedAppointment: selectedAppointment => set(() => ({ selectedAppointment }))
}));
